import React from 'react';
import PropTypes from 'prop-types';

import { SEARCH_RESULTS_META } from '../RacingThemeSearch/searchResultsContent';
import styles from './RacingThemeSearchResultsToolbar.module.css';

/**
 * Search results toolbar — count and sort.
 */
const RacingThemeSearchResultsToolbar = props => {
  const {
    count = SEARCH_RESULTS_META.count,
    query = SEARCH_RESULTS_META.query,
    sortOptions = SEARCH_RESULTS_META.sortOptions,
    activeSort = SEARCH_RESULTS_META.activeSort,
    onSortChange,
  } = props;

  const normalizedSortOptions = sortOptions.map(option =>
    typeof option === 'string' ? { value: option, label: option } : option
  );

  return (
    <div className={styles.resultsToolbar}>
      <p className={styles.resultsCount}>
        <strong>{count} results</strong>
        {query ? (
          <>
            {' '}
            for &quot;{query}&quot;
          </>
        ) : null}
      </p>
      <div className={styles.resultsControls}>
        <span className={styles.sortLabel}>Sort</span>
        <select
          className={styles.sortSelect}
          value={activeSort || normalizedSortOptions[0]?.value || ''}
          aria-label="Sort results"
          onChange={event => {
            if (typeof onSortChange === 'function') {
              onSortChange(event.target.value);
            }
          }}
        >
          {normalizedSortOptions.map(option => (
            <option key={option.value} value={option.value} disabled={option.disabled}>
              {option.label}
            </option>
          ))}
        </select>
      </div>
    </div>
  );
};

RacingThemeSearchResultsToolbar.propTypes = {
  count: PropTypes.number,
  query: PropTypes.string,
  sortOptions: PropTypes.arrayOf(
    PropTypes.oneOfType([
      PropTypes.string,
      PropTypes.shape({
        value: PropTypes.string.isRequired,
        label: PropTypes.string.isRequired,
        disabled: PropTypes.bool,
      }),
    ])
  ),
  activeSort: PropTypes.string,
  onSortChange: PropTypes.func,
};

export default RacingThemeSearchResultsToolbar;
